import { IosShareOutlined, MarkunreadMailboxOutlined } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { EditorRef } from 'react-email-editor';
import { useRef, useState } from 'react';
import Button from 'domains/core/components/Button';
import TextField from 'domains/core/components/TextField';
import PageHeader from 'domains/core/components/PageHeader';
import DirectMailEditor from './DirectMailEditor';

const ContentDirectMailBuilderPage = () => {
    const [name, setName] = useState('');
    const [isNameTouched, setIsNameTouched] = useState(false);

    const editorRef = useRef<EditorRef>(null);
    const unlayer = editorRef.current?.editor;

    const exportData = () => {
        unlayer?.exportHtml((data) => {
            // eslint-disable-next-line no-console
            console.log('export data: ', data);
        });
    };

    const exportPDF = () => {
        unlayer.exportPdf((data) => {
            window.open(data?.url, '_blank').focus();
        });
    };

    const isNameUndefinedOnTouch = !name && isNameTouched;
    const isNameTooShort = isNameTouched && name.length < 3;

    const getNameHelperText = () => {
        if (isNameUndefinedOnTouch) return 'Please enter a name';
        if (isNameTooShort) return 'Name must have at least 3 characters';
    };

    const handleChangeName = (e: any) => {
        if (!isNameTouched) {
            setIsNameTouched(true);
        }
        setName(e.target.value);
    };

    const handleSaveName = () => {
        // TODO: handle saving forreal
    };

    return (
        <Stack height="100%" mb={4} rowGap={4}>
            <div style={{ padding: '8px 0' }}>
                <TextField
                    data-testid="name-input"
                    error={isNameUndefinedOnTouch || isNameTooShort}
                    helperText={getNameHelperText()}
                    label="Name"
                    required
                    value={name}
                    width="20%"
                    withClickAway
                    onChange={handleChangeName}
                    onClickAway={handleSaveName}
                />
            </div>
            <Stack height="100%">
                <PageHeader
                    icon={<MarkunreadMailboxOutlined fontSize="inherit" />}
                    header="direct mail"
                    headerOthers={
                        <Stack
                            direction="row"
                            alignItems="center"
                            columnGap={1}
                            ml={1}
                            justifyContent="flex-end"
                            width="100%"
                        >
                            <Button
                                disabled={!unlayer}
                                onClick={exportPDF}
                                variant="outlined"
                                startIcon={<IosShareOutlined />}
                            >
                                Export PDF
                            </Button>
                            <Button
                                disabled={!unlayer}
                                // TODO: handle click forreal
                                onClick={exportData}
                                variant="outlined"
                            >
                                Save & Exit
                            </Button>
                        </Stack>
                    }
                />
                <DirectMailEditor editorRef={editorRef} />
            </Stack>
        </Stack>
    );
};

export default ContentDirectMailBuilderPage;
